import script from "./sw-item-parts-file.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-parts-file.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-parts-file.vue?vue&type=style&index=0&id=3d54a7fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d54a7fc"]])

export default __exports__